// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form[data-v-01419628]{max-width:350px;width:100%;-ms-flex-item-align:center;align-self:center;margin-left:auto!important;margin-right:auto!important;margin-top:50px}", ""]);
// Exports
module.exports = exports;
